import { render, staticRenderFns } from "./CoreSendEmailNotification.vue?vue&type=template&id=3daed854"
import script from "./CoreSendEmailNotification.vue?vue&type=script&lang=js"
export * from "./CoreSendEmailNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports